<template>
    <div class="form feedback__answer">
        <div class="feedback__answer-rate" >
            <span class="feedback__answer-rate-name">Оценка предоставленных услуг (от 1 до 5):</span>
            <el-rate
                    :icon-classes="iconClasses"
                    void-icon-class="icon-circle"
                    :void-color="goodColor"
                    :colors="colors"
                    class="feedback__answer-rate-value"
                    v-model="form.mark"
                    required>
            </el-rate>
        </div>
        <div class="feedback__textarea">
            <img :src="userAvatar" alt="#" class="avatar feedback__answer-avatar">
            <label class="field">
                <span class="field__caption">Отзыв</span>
                <el-input
                        type="textarea"
                        v-model="form.description"
                        autosize
                        :autosize="{ minRows: 2, maxRows: 7}"
                        required>
                </el-input>
            </label>
        </div>
        <label class="toggle" v-if="isAnonym || can && hasAppointment && access === 'patient'">
            <input class="toggle__input screen-reader" type="checkbox" v-model="form.anon">
            <span class="toggle__label">
                            <span class="toggle__text">АНОНИМНО</span>
                        </span>
        </label>
        <span v-if="requiredRete" class="feedback__error">Вы не можете оставить свой отзыв без оценки</span>
        <span v-if="requiredMessage" class="feedback__error">Пожалуйста, оставьте свой отзыв</span>
        <div class="feedback__answer-bottom">
            <button class="r-button button" @click="checkRate()">Оставить отзыв</button>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations,mapActions} from 'vuex';

    export default {
        name: "FormReview",
        data: () => ({
            can: window.laravel.can,
            iconClasses: ['icon-circle-back', 'icon-circle-back', 'icon-circle-back'],
            isBad: true,
            isGood: true,
            badColor: "#CC5D5D",
            goodColor: "#2A7FAC",
            colors: ["#CC5D5D", "#CC5D5D", "#2A7FAC"],
            value: 2,
            value_g: 4,
            open: false,
            open_g: true,
            requiredRete: false,
            requiredMessage: false,
            access: window.laravel.access,
            hasAppointment: window.laravel.hasAppointment,
            isAnonym: window.laravel.isAnonym,
        }),
        computed: {
            ...mapState([
                'userAvatar',
                'form'
            ]),
        },
        methods: {
            ...mapActions([
                'postReview',
            ]),
            checkRate() {
                this.requiredRete = !this.form.mark;
                this.requiredMessage = !this.form.description;

                if (this.form.mark && this.form.description) {
                    this.form.consultation = window.laravel.consultationId;
                    this.postReview();
                }
            },
        },
    }
</script>
